<div class="dialer">
  <app-status-bar [carrierName]="carrier" />

  <div class="dialer__display">
    <label class="bk-sr-only" for="ussd-dial-code">USSD code</label>
    <div class="dialer__code-row">
      <input
        #codeInput
        id="ussd-dial-code"
        class="dialer__code"
        type="text"
        inputmode="tel"
        autocomplete="off"
        spellcheck="false"
        placeholder="*123#"
        [value]="dialedCode"
        [disabled]="isLoading"
        (input)="onType($event)"
        (keydown)="onKeydown($event)"
      />
    </div>
    <p class="dialer__hint">{{ hint }}</p>
  </div>

  <div class="dialer__pad" role="group" aria-label="Dial pad">
    @for (key of dialPadKeys; track key.digit) {
      <button
        type="button"
        class="dialer__key"
        [disabled]="isLoading"
        [attr.aria-label]="key.digit === '*' ? 'Star' : key.digit === '#' ? 'Hash' : key.digit"
        (click)="press(key.digit)"
      >
        <span class="dialer__digit">{{ key.digit }}</span>
        <span class="dialer__letters">{{ key.letters || ' ' }}</span>
      </button>
    }

    <span class="dialer__spacer" aria-hidden="true"></span>
    <button
      type="button"
      class="dialer__call"
      aria-label="Dial"
      [disabled]="!dialedCode || isLoading"
      [attr.aria-busy]="isLoading || null"
      (click)="call.emit()"
    >
      @if (isLoading) {
        <span class="bk-sym dialer__spinner" aria-hidden="true">more_horiz</span>
      } @else {
        <span class="bk-sym bk-sym--fill" aria-hidden="true">call</span>
      }
    </button>
    <button
      type="button"
      class="dialer__delete"
      aria-label="Delete last character"
      [class.is-hidden]="!dialedCode"
      [disabled]="!dialedCode || isLoading"
      (click)="delete.emit()"
    >
      <span class="bk-sym" aria-hidden="true">backspace</span>
    </button>
  </div>

  <button type="button" class="dialer__home" aria-label="Home: clear the code" (click)="home.emit()">
    <span class="dialer__home-bar" aria-hidden="true"></span>
  </button>
</div>
